import React, { useEffect, useState } from 'react';
import { UHCImageListProps } from '../ImageList';
import { Image } from '../../../../Cloud.model';
import { UHCBadgeImage } from '../../../../../..';
import UHCImagePrice from '../../../../Atoms/Image/ImagePrice/ImagePrice';
import { UHCImageName } from '../../../../Atoms/Image/ImageName/ImageName';
import { Cards } from '../Card/ImageIconCard.model';
import { getCardByImage, isShowImageByCard } from '../Card/ImageIconCard.service';
import UHCLockImage, { UHCLockImageProps } from '../../LockImage/LockImage';

import './ImageListLines.scss'
import UHCIconImage from '../../../../Atoms/Image/IconImage/IconImage';
import { selectedHardwareDoesntSupportsSelectedImage } from '../../LockImage/utils';

export interface LinesProps {
    images: UHCImageListProps['images'],
    imageChecked: UHCImageListProps['imageChecked'],
    filter: Cards,
    hardware: UHCLockImageProps['hardware'],
    layout: UHCImageListProps['layout'],
    server?: UHCImageListProps['server'],
    setImageChecked: (images: Image[], index: number) => void,
    clickChangeHardware: (image: Image) => void
}

function isChecked(id1: Image['id'], id2: Image['id']) {
    return (id1 === id2)
}

const ImageListLines: React.FC<LinesProps> = (props: LinesProps) => {
    useEffect(() => {
        if ((getCardByImage(props.imageChecked)) == props.filter) return


        const avaiableImages = props.images.filter(image => isShowImageByCard(image, props.filter))
        const newSelectedImage = avaiableImages[0]

        if (!newSelectedImage) return

        props.setImageChecked(props.images, props.images.indexOf(newSelectedImage))

        if (selectedHardwareDoesntSupportsSelectedImage(newSelectedImage, props.hardware)) props.clickChangeHardware(newSelectedImage)
    }, [props.filter])

    const [currentLockOpen, setCurrentLockOpen] = useState<string>()
    const itemWidths = (props.layout === 'card') ?
        ['3%', '0%', '80%', '20%'] :
        ['3%', '10%', '75%', '10%']


    return (
        <div
            className="lines"
            role="tabpanel"
            id={`panel-id-${props.filter}`}
            aria-labelledby={`tab-id-${props.filter}`}
        >
            {props.images.map((val, index) => {
                if (props.layout === 'list' || isShowImageByCard(val, props.filter)) {

                    const classBorder = (index === 0) ? 'border-top border-end border-start' : 'border';

                    return (
                        <UHCLockImage
                            key={index}
                            image={val}
                            hardware={props.hardware}
                            handleClick={props.clickChangeHardware}
                            currentLockOpen={currentLockOpen}
                            setCurrentLockOpen={setCurrentLockOpen}
                        >
                            {(isBlocked) => (
                                <div
                                    key={index}
                                    className={`line d-flex ${classBorder} ${(isChecked(val.id, props.imageChecked.id)) ? "checked" : ""}`}
                                    onClick={() => {
                                        if (!isBlocked) props.setImageChecked(props.images, index)
                                    }}
                                >

                                    <input className="item zero-form-check__input" type="radio" id={val.id}
                                        onChange={() => { }}
                                        aria-disabled={isBlocked}
                                        checked={(
                                            isChecked(val.id, props.imageChecked.id)
                                        )}
                                    />

                                    <span style={{ width: itemWidths[0] }} className="item zero-form-check"></span>

                                    {(props.layout === 'list') ? (
                                        <span className="item" style={{ width: itemWidths[1] }} >
                                            <div className="icon">
                                                <UHCIconImage shortname={null} image={val} color />
                                            </div>
                                        </span>
                                    ) : null}
                                    <label htmlFor={val.id} className='item-label'>
                                        <div style={{ width: itemWidths[2] }} className="item d-flex flex-column">
                                            <div className='d-flex'>
                                                <span className="version">Versão</span>
                                                <UHCBadgeImage flags={val.flags} />
                                            </div>
                                            <span className="name">
                                                <UHCImageName image={val} showBits={true} />
                                            </span>
                                        </div>

                                        <div style={{ width: itemWidths[3] }} className='d-flex flex-column'>
                                            <span className="version">Licenciamento</span>
                                            <span className="item price name" >
                                                <UHCImagePrice image={val} server={props.server} />
                                            </span>
                                        </div>
                                    </label>
                                </div>
                            )}
                        </UHCLockImage>
                    )
                } else {
                    return (null)

                }

            })}
        </ div>
    )
}

export default ImageListLines;
